module.exports = __webpack_public_path__ + "img/image404.960c51ae.png";